const DONATION_TOKENS = [
    {
        symbol: 'SOL',
        name: 'Solana',
        mint: null,
        decimals: 9,
        isNative: true
    },
    {
        symbol: 'USDC',
        name: 'USD Coin',
        mint: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
        decimals: 6,
        isNative: false
    },
    {
        symbol: 'BONK',
        name: 'BONK',
        mint: 'DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263',
        decimals: null,
        isNative: false
    },
    {
        symbol: 'SKR',
        name: 'Seeker',
        mint: 'SKRbvo6Gf7GondiT3BbTfuRDPqLWei4j2Qy2NPGZhW3',
        decimals: null,
        isNative: false
    },
    {
        symbol: 'ORE',
        name: 'ORE',
        mint: 'oreoU2P8bN6jkk3jbaiVxYnG1dCXcYxwhwyK9jSybcp',
        decimals: 11,
        isNative: false
    },

    {
        symbol: 'GOATS',
        name: 'GOATS OF SOLANA',
        mint: 'BBLpindmy8n5ACcYyQmwsZbsT651g9u7C8TdKcgFBAGS',
        decimals: 9,
        isNative: false
    },
    {
        symbol: 'TOADS',
        name: 'Poet Toads',
        mint: 'DMXBsVBwfuzc5axa2vz6Ba2BzAxcUmn6V7ZtsJFEpump',
        decimals: null,
        isNative: false
    },
    {
        symbol: 'LSP',
        name: 'Lambo Space Princess',
        mint: 'BAy5FmGzFwcVcZq1yXaDvF1mEAChF3MPtBLrUMBsnLN9',
        decimals: 6,
        isNative: false
    },


];

module.exports = { DONATION_TOKENS };

